












import { Component, Mixins, Prop } from "vue-property-decorator";
import { TextBoxInputMethodKinds } from "../../../../domain/document/inputMethodKinds";
import { TextBoxInputMethodOptionKinds } from "../../../../domain/document/inputMethodOptionKinds";
import { ScreenKinds } from "../../../../domain/his/behavior/ScreenKinds";
import TextBoxWrapperObject from "../../../document/editor/objects/TextBoxWrapperObject.vue";
import InputMethodSelector from "./InputMethodSelector.vue";
import Enumerable from "linq";

@Component({
  components: {
    InputMethodSelector,
  }
})
export default class TextBoxInputMethodSelector extends Mixins() {
  @Prop()
  source: TextBoxWrapperObject;

  @Prop({ default: true })
  isUnselectionEnable: boolean;

  get optionSet(): TextBoxInputMethodKinds[] {
    if (this.source.isEditDisabledByRuleSet) {
      return [];
    }
    const kinds = this.optionSets[this.source.inputMethodOptionKind];
    const options = Enumerable.from(kinds)
      .where(k => this.shouldFreeInput(k) && this.shouldHisInfoSelectInput(k) && this.existsItems(k))
      .toArray();
    // フリー入力のみの場合は空にする
    return options.length === 1 && options[0] === TextBoxInputMethodKinds.FreeInput
      ? []
      : options;
  }

  private shouldFreeInput(kind: TextBoxInputMethodKinds): boolean {
    return this.source.isFreeInputable || kind !== TextBoxInputMethodKinds.FreeInput;
  }

  private shouldHisInfoSelectInput(kind: TextBoxInputMethodKinds): boolean {
    if (this.isInstitutionSelectItem()) { return true; }
    return this.source.isHisInfoSelectInputable || kind !== TextBoxInputMethodKinds.HisInfoSelect;
  }

  private existsItems(kind: TextBoxInputMethodKinds): boolean {
    if (this.isInstitutionSelectItem()) { return true; }
    // ユーザ定義は起動時にキャッシュしておけば対応できるのでHIS情報のみ判定
    const hisItemParameter = this.source.editingSource.hisItemParameter;
    return kind !== TextBoxInputMethodKinds.HisInfoSelect
      || hisItemParameter === null
      || hisItemParameter.screenKind !== ScreenKinds.List
      || this.source.commonComponents.editors.hisInformation.containsInformation(hisItemParameter.informationKind);
  }

  private isInstitutionSelectItem(): boolean {
    try {
      const hisItemParameter = this.source.editingSource.hisItemParameter;
      return hisItemParameter && hisItemParameter.isInstitutionSelect;
    } catch (e) {
      // Errorは発生しないはずだが念のためcatchしている
      return false;
    }
  }

  get unselection(): TextBoxInputMethodKinds {
    return this.isUnselectionEnable
      ? this.unselectionSets[this.source.inputMethodOptionKind]
      : null;
  }

  displayTexts: { key: TextBoxInputMethodKinds, text: string }[] = [
    { key: TextBoxInputMethodKinds.None, text: "入力不可" },
    { key: TextBoxInputMethodKinds.FreeInput, text: "フリー入力" },
    { key: TextBoxInputMethodKinds.HisInfoSelect, text: "データ選択" },
    { key: TextBoxInputMethodKinds.UserDefinitionSelect, text: "データ選択" },
    { key: TextBoxInputMethodKinds.MKSTemplate, text: "MKSテンプレート" },
    { key: TextBoxInputMethodKinds.DynamicTemplate, text: "ダイナミックテンプレート" },
  ];

  private optionSets: { [key in TextBoxInputMethodOptionKinds]: TextBoxInputMethodKinds[] } = {
    Normal: [], // 常にフリー入力なので切り替えない
    HisItem: [], // 常に入力できないので切り替えない
    HisFreeInput: [ TextBoxInputMethodKinds.FreeInput, TextBoxInputMethodKinds.None ],
    HisInfoSelect: [ TextBoxInputMethodKinds.FreeInput, TextBoxInputMethodKinds.HisInfoSelect ],
    UserDefinition: [ TextBoxInputMethodKinds.FreeInput, TextBoxInputMethodKinds.UserDefinitionSelect ],
    MKSTemplate: [ TextBoxInputMethodKinds.FreeInput, TextBoxInputMethodKinds.MKSTemplate ],
    DynamicTemplate: [ TextBoxInputMethodKinds.FreeInput, TextBoxInputMethodKinds.DynamicTemplate ],
  };

  private unselectionSets: { [key in TextBoxInputMethodOptionKinds]: TextBoxInputMethodKinds } = {
    Normal: null,
    HisItem: null,
    HisFreeInput: TextBoxInputMethodKinds.None,
    HisInfoSelect: null,
    UserDefinition: null,
    MKSTemplate: null,
    DynamicTemplate: null,
  };
}
